import { Injectable } from '@angular/core';
import {FabricService} from 'src/app/services/fabric/fabric.service';
import {catchError, finalize, map, Observable, of, retry, throwError, timeout, TimeoutError} from 'rxjs';


const SERVICE_NAME = 'mgmt-dbbackup-resources';

@Injectable({
  providedIn: 'root'
})
export class DbbackupService {

  constructor(private fabricService: FabricService) {}

  getInstanceDatabases(id): any {
    return this.fabricService.invokeOperation<any>(SERVICE_NAME, 'get_mgmt_instances_id_databases', {id});
  }
  postInstanceDbBackup(data): any {
    return this.fabricService.invokeOperation<any>(SERVICE_NAME, 'post_mgmt_instances_id_db-backups', data);
  }
  getInstanceDbBackups(id,size?:Number): any {
    return this.fabricService.invokeOperation<any>(SERVICE_NAME, 'get_mgmt_instances_id_db-backups', {id,size});
  }
  getInstanceDbBackupById(id,backupId): any {
    return this.fabricService.invokeOperation<any>(SERVICE_NAME, 'get_mgmt_instances_id_db-backups_backupid', {id,backupId});
  }
  putInstanceDbBackupExtend(obj?): Observable<any>{
    return this.fabricService.invokeOperation<any>(SERVICE_NAME, 'put_mgmt_instances_id_db-backups_backupid_extend', obj);
  }
  deleteInstanceDbbackup(id,backupId): any{
    return this.fabricService.invokeOperation<any>(SERVICE_NAME, 'delete_mgmt_instances_id_db-backups_backupid', {id, backupId});
  }

  postInstanceRestore(obj): any {
    return this.fabricService.invokeOperation<any>(SERVICE_NAME, 'post_mgmt_instances_id_db-restores', obj);
  }

  getInstanceRestores(id, limit?): any {
    return this.fabricService.invokeOperation<any>(SERVICE_NAME, 'get_mgmt_instances_id_db-restores', {id, limit});
  }

  putInstanceRestore(id, restoreId): any {
    return this.fabricService.invokeOperation<any>(SERVICE_NAME, 'put_mgmt_instances_id_db-restores_restoreid_promote', {id, restoreId});
  }

  deleteInstanceRestore(id, restoreId): any {
    return this.fabricService.invokeOperation<any>(SERVICE_NAME, 'delete_mgmt_instances_id_db-restores_restoreid', {id, restoreId});
  }
}
